import { render, staticRenderFns } from "./Users_Follower_Loading.vue?vue&type=template&id=79b7c0b4&"
import script from "./Users_Follower_Loading.vue?vue&type=script&lang=js&"
export * from "./Users_Follower_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports